import { CreateSandboxModal } from "components/GlobalModal/CreateSandboxModal";
import { useEditor } from "features/editor/Feature";
import { useEffect, useState } from "react";

import { useEditorRouter } from "hooks/useEditorRouter";

export const CreateBoxModalLoader = () => {
  const router = useEditorRouter();
  const editor = useEditor();
  const [modalVisibility, setModalVisibility] = useState(false);

  useEffect(() => {
    if (
      editor.type === "sandbox" &&
      router.queryParams.fork.get() !== undefined
    ) {
      setModalVisibility(true);
    }
  }, []);

  if (modalVisibility && editor.type === "sandbox") {
    return (
      <CreateSandboxModal
        close={() => setModalVisibility(false)}
        initialPrivacy={router.queryParams.privacy.get()}
        sandboxId={editor.id}
        type={editor.isCloud ? "devbox" : "sandbox"}
      />
    );
  }

  return null;
};
